<template>
    <div data-cy="protein-veggie">
        <ion-segment mode="md" :value="selected" @ionChange="toggle($event.target.value)">
            <ion-segment-button value="protein" data-cy="button-protein" style="font-size: 1.3rem"> Proteins</ion-segment-button>
            <ion-segment-button value="veggies" data-cy="button-veggies" style="font-size: 1.3rem"> Veggies &amp; More </ion-segment-button>
        </ion-segment>
        <div v-if="availableTopping && protein && veg" :class="checklistClass" class="px-m8" style="margin-top: 10px">
            <checklist v-if="selected === 'protein'" :items="protein" @update="protein = $event" :hideSplitOpts="hideSplitOpts" data-cy="checklist-protein" />
            <checklist v-else :items="veg" @update="veg = $event" :hideSplitOpts="hideSplitOpts" data-cy="checklist-veggies" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, nextTick } from 'vue';
import { IonSegment, IonSegmentButton } from '@ionic/vue';
import baseToppings, { passThroughBindings } from '@/components/menu/toppings/baseToppings.vue';
import { menuActionScroller } from '@/services/pageService';
import checklist from '@/components/menu/toppings/checklist.vue';

export default defineComponent({
    extends: baseToppings,
    props: { checklistClass: String, autoScroll: Boolean },
    components: { IonSegment, IonSegmentButton, checklist },
    setup(props, { emit }) {
        const selected = ref('protein');
        const { localToppings } = passThroughBindings(props, emit);
        const protein = ref();
        const veg = ref();
        const toggle = (isToggled) => {
            selected.value = isToggled;
            if (props.autoScroll) menuActionScroller(3);
        };

        nextTick(() => {
            protein.value = localToppings.value?.filter((t) => t.isMeat);
            veg.value = localToppings.value?.filter((t) => !t.isMeat);
        });

        watch(protein, () => (localToppings.value = [...(protein?.value ?? []), ...(veg?.value ?? [])]));
        watch(veg, () => (localToppings.value = [...(protein?.value ?? []), ...(veg?.value ?? [])]));

        return { selected, protein, veg, localToppings, toggle };
    },
});
</script>

<style scoped>
ion-segment-button {
    --margin-bottom: 0;
    max-width: 50vw;
}
</style>
